import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-medium px-3 py-1.5 rounded-full mb-4">
            Start Shopping Now
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Compare &amp; Buy Smarter
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-xl mx-auto leading-relaxed">
            Access the complete GTBuy spreadsheet system to compare prices, track deals, 
            and discover the best products across multiple categories.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              GTBuy Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="border-2 border-foreground-200 hover:border-foreground-400 text-foreground-800 px-8 py-3.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>

        <div className="mt-12 flex justify-center gap-4 md:gap-6 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=White%20minimal%20sneakers%20isolated%20on%20clean%20cream%20background%20product%20photography%20soft%20natural%20light%20editorial%20style%20scandinavian%20aesthetic&width=200&height=200&seq=gtbuy-cta-strip-1&orientation=squarish"
            alt="Shoes product"
            title="Shoes"
            className="w-16 h-16 md:w-20 md:h-20 object-cover object-top rounded-xl flex-shrink-0"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20leather%20handbag%20with%20gold%20hardware%20on%20cream%20background%20minimal%20product%20photography%20soft%20lighting%20luxury%20aesthetic%20clean%20composition&width=200&height=200&seq=gtbuy-cta-strip-2&orientation=squarish"
            alt="Bags product"
            title="Bags"
            className="w-16 h-16 md:w-20 md:h-20 object-cover object-top rounded-xl flex-shrink-0"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Minimal%20baseball%20cap%20beige%20color%20on%20cream%20surface%20product%20photography%20clean%20aesthetic%20soft%20natural%20light%20editorial%20style&width=200&height=200&seq=gtbuy-cta-strip-3&orientation=squarish"
            alt="Headwear product"
            title="Headwear"
            className="w-16 h-16 md:w-20 md:h-20 object-cover object-top rounded-xl flex-shrink-0"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Designer%20sunglasses%20with%20gold%20frame%20on%20cream%20marble%20surface%20minimal%20product%20photography%20soft%20lighting%20editorial%20style%20luxury%20aesthetic&width=200&height=200&seq=gtbuy-cta-strip-4&orientation=squarish"
            alt="Accessories product"
            title="Accessories"
            className="w-16 h-16 md:w-20 md:h-20 object-cover object-top rounded-xl flex-shrink-0"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirt%20folded%20neatly%20cream%20color%20on%20light%20wooden%20surface%20minimal%20product%20photography%20soft%20natural%20light%20editorial%20style&width=200&height=200&seq=gtbuy-cta-strip-5&orientation=squarish"
            alt="T-Shirts product"
            title="T-Shirts"
            className="w-16 h-16 md:w-20 md:h-20 object-cover object-top rounded-xl flex-shrink-0"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottle%20with%20golden%20liquid%20on%20cream%20background%20minimal%20product%20photography%20soft%20lighting%20luxury%20aesthetic%20clean%20composition&width=200&height=200&seq=gtbuy-cta-strip-6&orientation=squarish"
            alt="Perfumes product"
            title="Perfumes"
            className="w-16 h-16 md:w-20 md:h-20 object-cover object-top rounded-xl flex-shrink-0"
          />
        </div>
      </div>
    </section>
  );
}